import {
    HomeOutlined,
    CompassOutlined,
    WalletOutlined,
    LineChartOutlined,
    RedEnvelopeOutlined,
    RobotOutlined,
    UserOutlined,
    GiftOutlined,
    QuestionCircleOutlined,
    ShareAltOutlined,
    LoadingOutlined,
} from '@ant-design/icons';
import type { MenuProps } from 'antd';
import type { TFunction } from 'i18next';

export function getMenuItems(
    voucherCount: number,
    voucherCountLoading: boolean,
    t: TFunction
): MenuProps['items'] {
    return [
        {
            key: '/home',
            icon: <HomeOutlined />,
            label: t('nav.home'),
        },
        {
            key: '/explore',
            icon: <CompassOutlined />,
            label: t('nav.explore'),
        },
        {
            key: '/wallet',
            icon: <WalletOutlined />,
            label: t('nav.wallet'),
        },
        {
            key: '/vouchers',
            icon: <GiftOutlined />,
            label: (
                <span className="sidebar__item-label">
                    {t('nav.vouchers')}
                    <span
                        className="sidebar__badge"
                        aria-label={
                            voucherCountLoading
                                ? t('a11y.loadingVoucherCount')
                                : t('units.voucher', { count: voucherCount })
                        }
                    >
                        {voucherCountLoading ? <LoadingOutlined spin /> : voucherCount}
                    </span>
                </span>
            ),
        },
        {
            key: '/account',
            icon: <UserOutlined />,
            label: t('nav.account'),
        },
    ];
}

export function getUtilityMenuItems(t: TFunction): MenuProps['items'] {
    return [
        {
            key: '/help',
            icon: <QuestionCircleOutlined />,
            label: t('nav.help'),
        },
        {
            key: '/ecosystem',
            icon: <ShareAltOutlined />,
            label: t('nav.ecosystem'),
        },
    ];
}

export const PAGE_TITLE_KEYS: Record<string, string> = {
    '/home': 'nav.home',
    '/explore': 'nav.explore',
    '/wallet': 'nav.wallet',
    '/activity': 'nav.activity',
    '/red-packet': 'nav.redPacket',
    '/ai-agents': 'nav.aiAgents',
    '/account': 'nav.account',
    '/vouchers': 'nav.vouchers',
    '/help': 'nav.help',
    '/ecosystem': 'nav.ecosystem',
};
